import {
  calculateFactionTotalScore,
  getFactionMemberPoints,
} from './factionScoring';
import { getEffectiveFactionMemberStatus } from './factionLineupRole';

export const isFactionRosterResolutionPending = ({ faction, roster = null }) =>
  Boolean(faction?.rosterId && !roster);

export const calculateHomeFactionTotalScore = ({
  faction,
  roster = null,
  members = [],
  wrestlerScoresById = {},
  referenceDate = new Date(),
}) => {
  if (isFactionRosterResolutionPending({ faction, roster })) return 0;

  return calculateFactionTotalScore({
    faction,
    roster,
    members,
    wrestlerScoresById,
    referenceDate,
  });
};

export const getHomeFactionMemberPoints = ({
  faction,
  roster = null,
  member,
  wrestler,
  referenceDate = new Date(),
}) => {
  if (!member || !wrestler) return 0;
  if (isFactionRosterResolutionPending({ faction, roster })) return 0;

  const effectiveStatus = getEffectiveFactionMemberStatus({
    faction,
    wrestlerId: member.id,
    fallbackStatus: member.status || null,
    referenceDate,
  });

  return getFactionMemberPoints({
    faction,
    roster,
    wrestlerId: member.id,
    currentScore: wrestler.score || 0,
    startScore: member.startScore || 0,
    status: effectiveStatus,
    referenceDate,
  });
};

export const buildHomeTopWrestlerCandidate = ({
  faction,
  roster = null,
  member,
  wrestler,
  referenceDate = new Date(),
}) => {
  if (!member || !wrestler) return null;

  const effectiveStatus = getEffectiveFactionMemberStatus({
    faction,
    wrestlerId: member.id,
    fallbackStatus: member.status || null,
    referenceDate,
  });

  return {
    id: wrestler.id,
    name: wrestler.name,
    brand: wrestler.brand || 'Indy',
    currentScore: wrestler.score || 0,
    pointsDifference: getHomeFactionMemberPoints({
      faction,
      roster,
      member,
      wrestler,
      referenceDate,
    }),
    imageUrl: wrestler.imageUrl || '/assets/default-wrestler.png',
    status: effectiveStatus,
  };
};
